<template >
<div class="flex flex-col justify-center mt-24">
  <h1 class=" text-3xl mb-8 font-bold">🌦 Weather In</h1>
  <form class="" @submit.prevent="getWeather">
    <!-- <input class=" shadow-lg shadow-slate-400	border rounded pl-4  py-6 mr-4"  placeholder="Enter your First Name" v-model="name" type="text" id="location" /> -->
    <input class=" shadow-lg shadow-slate-400	border rounded pl-4 pr-8 py-6 mr-4"  placeholder="Enter a Location" v-model="location" type="text" id="location" />
    
    <button class="shadow-lg hover:shadow-slate-400 btn bg-orange-500 text-white rounded-full px-6 py-4">Get Weather</button>
  </form>
  </div>
<div v-if="weatherData">
    <WeatherData :weatherData="weatherData"/>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import WeatherData from './WeatherData.vue'


    const location = ref('')
    const weatherData = ref(null)

    async function getWeather() {
      const apiKey = 'daebc31c6403875d00d0819948dcfcf3'
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${location.value}&appid=${apiKey}`
      const response = await fetch(url)
      weatherData.value = await response.json()
    }

    

</script>
<style>
#location{
    width: 20rem;
    height: 2rem;
}
button{
border: none;
padding: 1rem;
background: #0087c5;
color: #ffffff;
}


</style>